<template>
  <img alt="Songstar logo" class="logo" src="/src/assets/songstar-logo.png" />
</template>

<style scoped>
  .logo {
    display: block;
    height: var(--logo-size, 10rem);
    object-fit: contain;
    width: var(--logo-size, 10rem);
  }
</style>
